/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AtlasHashResponse
 */
export interface AtlasHashResponse {
    /**
     * 
     * @type {string}
     * @memberof AtlasHashResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof AtlasHashResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AtlasHashResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AtlasHashResponse
     */
    userHash: string;
}

/**
 * Check if a given object implements the AtlasHashResponse interface.
 */
export function instanceOfAtlasHashResponse(value: object): value is AtlasHashResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('userHash' in value) || value['userHash'] === undefined) return false;
    return true;
}

export function AtlasHashResponseFromJSON(json: any): AtlasHashResponse {
    return AtlasHashResponseFromJSONTyped(json, false);
}

export function AtlasHashResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtlasHashResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'name': json['name'],
        'email': json['email'],
        'userHash': json['userHash'],
    };
}

export function AtlasHashResponseToJSON(json: any): AtlasHashResponse {
    return AtlasHashResponseToJSONTyped(json, false);
}

export function AtlasHashResponseToJSONTyped(value?: AtlasHashResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'name': value['name'],
        'email': value['email'],
        'userHash': value['userHash'],
    };
}

